<!-- ═══════════════════════════════════════════════════════════════════════════
     Section: DEPLOYMENT PROTOCOL — "PATH TO THE VOID"
     id="protocol" anchored for header nav
  ════════════════════════════════════════════════════════════════════════════ -->
<section class="protocol" aria-labelledby="protocol-heading">

  <!-- Decorative circuit grid overlay (CSS) -->
  <div class="protocol__grid-overlay" aria-hidden="true"></div>

  <div class="protocol__container">

    <!-- Section header -->
    <div class="protocol__header">
      <p class="protocol__eyebrow">{{ 'feature.protocol_eyebrow' | translate }}</p>
      <h2 class="protocol__title" id="protocol-heading">{{ 'feature.protocol_title' | translate }}</h2>
    </div>

    <!-- 3-step cards -->
    <div class="protocol__cards">

      @for (step of steps; track step.titleKey; let i = $index) {
        <article class="protocol__card" [class.protocol__card--offset]="i === 1"
                 [style.--accent]="step.accent">
          <!-- Icon container -->
          <div class="protocol__card-icon" aria-hidden="true">
            @if (i === 0) {
              <!-- Wallet / connect icon -->
               <img src="/assets/images/svg-icons/wallet-icon.svg" class="img-fluid" alt="Wallet icon"/>
              <!-- <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 7H2C1.45 7 1 7.45 1 8v12c0 .55.45 1 1 1h20c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1Z" [attr.stroke]="step.accent" stroke-width="1.5"/>
                <path d="M17 7V4c0-.55-.45-1-1-1H4C2.9 3 2 3.9 2 5v2" [attr.stroke]="step.accent" stroke-width="1.5"/>
                <circle cx="18" cy="14" r="2" [attr.fill]="step.accent"/>
              </svg> -->
            }
            @if (i === 1) {
              <!-- Chart / predict icon -->
               <img src="/assets/images/svg-icons/predict-icon.svg" class="img-fluid" alt="Wallet icon" />

              <!-- <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <polyline points="2,16 8,10 13,14 22,4" [attr.stroke]="step.accent" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="2" y1="20" x2="22" y2="20" [attr.stroke]="step.accent" stroke-width="1.5" stroke-linecap="round"/>
              </svg> -->
            }
            @if (i === 2) {
              <!-- Profit / arrow-up icon -->
               <img src="/assets/images/svg-icons/coin-icon.svg" class="img-fluid" alt="Wallet icon" />

              <!-- <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="11" r="9" [attr.stroke]="step.accent" stroke-width="1.5"/>
                <polyline points="8,13 12,7 16,13" [attr.stroke]="step.accent" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="12" y1="7" x2="12" y2="15" [attr.stroke]="step.accent" stroke-width="1.5" stroke-linecap="round"/>
              </svg> -->
            }
          </div>

          <h3 class="protocol__card-title">{{ step.titleKey | translate }}</h3>
          <p class="protocol__card-body">{{ step.bodyKey | translate }}</p>
        </article>
      }

    </div>
  </div>

</section>

<!-- ═══════════════════════════════════════════════════════════════════════════
     Section: GLOBAL PULSE — live activity marquee ticker
     id="analytics" anchored for header nav
  ════════════════════════════════════════════════════════════════════════════ -->
<!-- <section class="pulse" id="analytics" aria-label="Global Pulse — live trading activity">

   <div class="container">
  <div class="pulse__header">
    <span class="pulse__live-dot" aria-label="Live" role="img"></span>
    <h2 class="pulse__title">{{ 'feature.pulse_title' | translate }}</h2>
  </div>
  </div>

  <div class="pulse__band" aria-hidden="true">
    <div class="pulse__track">
      @for (item of activities; track item.token + item.timestamp) {
        <div class="pulse__item">
          <div class="pulse__token-badge" [style.color]="item.tokenColor"
               [style.background]="item.tokenColor + '33'">
            {{ item.token }}
          </div>
          <div class="pulse__item-content">
            <span class="pulse__item-label">{{ item.label }}</span>
            <span class="pulse__item-body">
              {{ item.bodyPre }}<strong [style.color]="item.amountColor">{{ item.amount }}</strong>
            </span>
          </div>
          <span class="pulse__item-time">{{ item.timestamp }}</span>
        </div>
      }
    </div>
    <div class="pulse__track" aria-hidden="true">
      @for (item of activities; track item.token + item.timestamp + '_dup') {
        <div class="pulse__item">
          <div class="pulse__token-badge" [style.color]="item.tokenColor"
               [style.background]="item.tokenColor + '33'">
            {{ item.token }}
          </div>
          <div class="pulse__item-content">
            <span class="pulse__item-label">{{ item.label }}</span>
            <span class="pulse__item-body">
              {{ item.bodyPre }}<strong [style.color]="item.amountColor">{{ item.amount }}</strong>
            </span>
          </div>
          <span class="pulse__item-time">{{ item.timestamp }}</span>
        </div>
      }
    </div>
  </div>

</section> -->
